function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "discount",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_343",
  "data-name": "Path 343",
  d: "M221.239,153.639l-2.581-3.441-1.435,10.044A4.351,4.351,0,0,1,216,162.688l-17.668,17.668a8.114,8.114,0,0,1-5.776,2.39,8.245,8.245,0,0,1-1.912-.225,5.285,5.285,0,0,0,4.455,2.446h21.143a5.292,5.292,0,0,0,5.286-5.286V154.5A1.442,1.442,0,0,0,221.239,153.639Z",
  transform: "translate(-172.322 -135.763)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_93",
  "data-name": "Ellipse 93",
  cx: 1.442,
  cy: 1.442,
  r: 1.442,
  transform: "translate(28.306 21.066)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_94",
  "data-name": "Ellipse 94",
  cx: 1.442,
  cy: 1.442,
  r: 1.442,
  transform: "translate(11.997 21.066)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_344",
  "data-name": "Path 344",
  d: "M23.971,42.555,41.64,24.886a1.442,1.442,0,0,0,.408-.815L44.086,9.8a1.442,1.442,0,0,0-.408-1.223L40.62,5.519,36.543,9.6l1.019,1.019a1.442,1.442,0,1,1-2.039,2.039L31.447,8.577a1.442,1.442,0,0,1,2.039-2.039L34.5,7.557,38.582,3.48,35.524.422A1.443,1.443,0,0,0,34.3.014L20.03,2.053a1.442,1.442,0,0,0-.815.408L1.546,20.129a5.292,5.292,0,0,0,0,7.475L16.5,42.555a5.292,5.292,0,0,0,7.475,0Zm5.776-24.371a4.325,4.325,0,1,1-4.325,4.325A4.33,4.33,0,0,1,29.747,18.183ZM13.438,26.832a4.325,4.325,0,1,1,4.325-4.325A4.33,4.33,0,0,1,13.438,26.832ZM18.2,34.143a1.442,1.442,0,0,1-1.368-1.9l6.8-20.387a1.442,1.442,0,1,1,2.735.912l-6.8,20.387A1.442,1.442,0,0,1,18.2,34.143Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_345",
  "data-name": "Path 345",
  d: "M406.554,2.461A1.442,1.442,0,0,0,404.515.422L401.457,3.48,403.5,5.519Z",
  transform: "translate(-362.875 0)",
  fill: "#ac1ede"
}));

var SvgDiscount = function SvgDiscount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.205,
    height: 49.205,
    viewBox: "0 0 49.205 49.205",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiscount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discount.8cd478a1.svg";
export { ForwardRef as ReactComponent };